import has from 'lodash/has';

import {
  brandDisclosureByBrand,
  defaultBrandDisclosure,
} from '../constants/brandDisclosures';
import { BrandDisclosure } from '../types/BrandDisclosure';

export const toBrandDisclosure = (brand: string): BrandDisclosure =>
  has(brandDisclosureByBrand, brand)
    ? brandDisclosureByBrand[brand]
    : defaultBrandDisclosure;
